'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

const STATUS_CONFIG: Record<string, { color: string; label: string }> = {
  CREATED: { color: 'bg-gray-100 text-gray-700', label: 'Created' },
  PROCESSING: { color: 'bg-blue-100 text-blue-700', label: 'Processing' },
  READY: { color: 'bg-green-100 text-green-700', label: 'Ready' },
  ERROR: { color: 'bg-red-100 text-red-700', label: 'Error' },
};

interface TerritoryItemProps {
  territory: MedScout.Territory;
  isSelected: boolean;
  onSelect: (territory: MedScout.Territory) => void;
}

const TerritoryItem: React.FC<TerritoryItemProps> = ({
  territory,
  isSelected,
  onSelect,
}) => {
  const statusConfig = territory.status
    ? STATUS_CONFIG[territory.status] || STATUS_CONFIG.CREATED
    : null;

  return (
    <div
      data-testid={`territory-option-${territory.id}`}
      className="flex items-center gap-2 px-4 py-3 cursor-pointer hover:bg-neutral-50 transition-colors"
      role="option"
      aria-selected={isSelected}
      onClick={() => onSelect(territory)}
    >
      <span className="text-sm text-primary truncate min-w-0">
        {territory.name}
        {territory.is_canonical ? ' (primary)' : ''}
      </span>
      {statusConfig && territory.status !== 'READY' && (
        <span
          className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium flex-shrink-0 ${statusConfig.color}`}
        >
          {statusConfig.label}
        </span>
      )}
      {isSelected && (
        <Icon
          icon={faCheck}
          className="w-3.5 h-3.5 text-primary ml-auto flex-shrink-0"
          data-testid={`territory-check-${territory.id}`}
        />
      )}
    </div>
  );
};

export default TerritoryItem;
